// This is the Client-side UI Interface for the Contact/Personal Details screen, providing form validation.

const $ = App.common.jQuery

// Timeout after Submit in seconds
const SUBMIT_TIMEOUT = 20

const ContactDetailsForm = require('common/models/form-contact-details')
const FormValidation = require('client/js/helpers/form-validation')

class ContactDetailsUI {
   // Init is called when the page first loads.
   static init() {
      let form = $('#contact-details-form')
      FormValidation.init(form, ContactDetailsForm, (err, result) => {
         let formdata = form.serializeObject()
         // console.log('Contact Details validation', err, result, formdata)
         if (result) return; // Invalid!

         // Disable submit button for a bit to stop double-submits
         let subbtn = form.find('*[type="submit"]')
         subbtn.prop('disabled', true)
         subbtn.addClass('continuing')
         setTimeout(()=> {
            subbtn.prop('disabled', false)
            subbtn.removeClass('continuing')
         }, SUBMIT_TIMEOUT * 1000)

         // Really submit
         form.trigger('submit')
      })
   }
}

module.exports = ContactDetailsUI
